import * as React from 'react';
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { BarChart } from '@mui/x-charts/BarChart';

function VoteBarChart(props) {
  const totalVotes = props.upvotes + props.downvotes;
  const upvotePercentage = totalVotes === 0 ? 0 : (props.upvotes / totalVotes) * 100;
  const downvotePercentage = totalVotes === 0 ? 0 : (props.downvotes / totalVotes) * 100;

  return (
    <BarChart
      yAxis={[
        {
          id: 'barCategories',
          data: ['Votes'],
          scaleType: 'band',
        },
      ]}
      series={[
        {
          data: [upvotePercentage],
          stack: 'a',
          color: '#4caf50',
          label: 'Yes',
          valueFormatter: (value) => `${value.toFixed(1)}%`,
        },
        {
          data: [downvotePercentage],
          stack: 'a',
          color: '#f44336',
          label: 'No',
          valueFormatter: (value) => `${value.toFixed(1)}%`,
        },
      ]}
      height={150}
      layout="horizontal"
      slotProps={{
        tooltip: {
          formatter: (value, series) => {
            const percentage = series.valueFormatter 
              ? series.valueFormatter(value) 
              : `${value.toFixed(1)}%`;
            return `${series.label}: ${percentage}`;
          },
        },
      }}
    />
  );
}

function VoteButtons({ login, handleVote, voted, voteScore, feedback }) {
  return (
    <div>
      {login.loggedin ? (
        <h3>Cast a vote</h3>
      ) : (
        <h3>Please log in to cast a vote</h3>
      )}
      {login.loggedin ? (
        <div className="SmishTitleContainer">
          <Button
            disabled={voted && voteScore !== "Yes"}
            onClick={(e) => handleVote("down")}
            variant="contained"
            color="primary"
            className="addSmishTitle"
          >
            No
          </Button>
          <Button
            disabled={voted && voteScore !== "No"}
            onClick={(e) => handleVote("up")}
            variant="contained"
            color="primary"
            className="addSmishTitle"
          >
            Yes
          </Button>
        </div>
      ) : (
        <div className="SmishTitleContainer">
          <span className="label-align">&nbsp;</span>
          <Button
            component={Link}
            to="/login"
            variant="contained"
            color="default"
            className="addSmishTitle"
          >
            Login
          </Button>
        </div>
      )}
      {feedback && <span className="label-align">{feedback}</span>}
      {!feedback && <span className="label-align">&nbsp;</span>}
    </div>
  );
}


export {VoteBarChart,VoteButtons};